import { getNewSearchParams } from './GetNewSearchParams';

export const getNewLinkParams = (router, addCustomParams) => {
  const params = getNewSearchParams(router.asPath, addCustomParams);

  let as = router.asPath.split('?')[0];
  const stringifiedParams = params.toString();
  if (stringifiedParams?.length) {
    as = `${as}?${stringifiedParams}`;
  }

  return {
    as,
    params,
    href: router.pathname,
  };
};
